module.exports = __webpack_public_path__ + "img/crocus.e9a083d6.png";